import root from 'window-or-global';
import {generateRoutePath} from '@epic-core/common';
import {LauncherBridge} from '../launcherBridge';
import {createClassLogger, Logger} from '../../utils/Logging';

const logger: Logger = createClassLogger('LauncherBridge:Mock');
let _isSSOEnabled = false;

const launcherMock: LauncherBridge = {
    getAccessToken: async (): Promise<string> => {
        logger.info('getAccessToken', 'MOCKED, with simulated response');
        return '';
    },

    requestSignIn: async (redirectUrl: string): Promise<void> => {
        logger.info('requestSignIn', 'MOCKED, with simulated response', {redirectUrl});
        root.location.href = generateRoutePath(redirectUrl, true);
    },

    isSSOEnabled: async (): Promise<boolean> => {
        logger.info('isSSOEnabled', 'MOCKED, with simulated response');
        return _isSSOEnabled;
    },

    setSSOEnabled: async (value: boolean): Promise<void> => {
        logger.info('setSSOEnabled', 'MOCKED, with simulated response', {value});
        _isSSOEnabled = value;
    }
};

export default launcherMock;
